// extracted by mini-css-extract-plugin
module.exports = {"Page":"ManagerAreas_Page__2MIt5","FilterSelect":"ManagerAreas_FilterSelect__3GsC4"};